<template>
  <div class="not-found">
    <a-result status="404" title="404" sub-title="非常抱歉，找不到当前访问页面">
      <template #extra>
        <a-button type="primary" @click="returnPage">回到首页</a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
  export default {
    name: 'NotFound',
    methods: {
      returnPage() {
        this.$store.commit('setRedirectUrl', null);
        this.$router.replace('/');
      }
    },
  }
</script>

<style lang="less" scoped>

</style>